import { addDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { useEffect, useRef, useState } from 'react';
import './App.css';
import { db } from './firebase';

// --- ENLACES DEL SLIDER (ESCRITORIO) ---
const heroImagesDesktop = [
  '/img/slide_Rancho_Licona-01.jpg', 
  '/img/slide_Rancho_Licona-02.jpg', 
  '/img/slide_Rancho_Licona-03.jpg', 
  '/img/slide_Rancho_Licona-04.jpg'
];

// --- ENLACES DEL SLIDER (MÓVIL) ---
const heroImagesMobile = [
  '/img/slide_Rancho_Licona-01-movil.jpg', 
  '/img/slide_Rancho_Licona-02-movil.jpg', 
  '/img/slide_Rancho_Licona-03-movil.jpg', 
  '/img/slide_Rancho_Licona-04-movil.jpg'
];

// --- ENLACES DE LA GALERÍA ---
const galleryImages = [
  "/img/galeria/galeria-01.jpg", "/img/galeria/galeria-02.jpg", "/img/galeria/galeria-03.jpg",
  "/img/galeria/galeria-04.jpg", "/img/galeria/galeria-05.jpg", "/img/galeria/galeria-06.jpg",
  "/img/galeria/galeria-07.jpg", "/img/galeria/galeria-08.jpg", "/img/galeria/galeria-09.jpg",
  "/img/galeria/galeria-10.jpg", "/img/galeria/galeria-11.jpg", "/img/galeria/galeria-12.jpg",
  "/img/galeria/galeria-13.jpg", "/img/galeria/galeria-14.jpg", "/img/galeria/galeria-15.jpg",
  "/img/galeria/galeria-16.jpg", "/img/galeria/galeria-17.jpg", "/img/galeria/galeria-18.jpg",
  "/img/galeria/galeria-19.jpg", "/img/galeria/galeria-20.jpg", "/img/galeria/galeria-21.jpg",
  "/img/galeria/galeria-22.jpg", "/img/galeria/galeria-23.jpg", "/img/galeria/galeria-24.jpg",
  "/img/galeria/galeria-25.jpg", "/img/galeria/galeria-26.jpg", "/img/galeria/galeria-27.jpg",
  "/img/galeria/galeria-28.jpg", "/img/galeria/galeria-29.jpg", "/img/galeria/galeria-30.jpg",
  "/img/galeria/galeria-31.jpg", "/img/galeria/galeria-32.jpg", "/img/galeria/galeria-33.jpg",
  "/img/galeria/galeria-34.jpg", "/img/galeria/galeria-35.jpg", "/img/galeria/galeria-36.jpg",
  "/img/galeria/galeria-37.jpg", "/img/galeria/galeria-38.jpg", "/img/galeria/galeria-39.jpg",
  "/img/galeria/galeria-40.jpg"
];

const AmenityCard = ({ icon, title, description }) => (
  <div className="amenity-card">
    <div className="amenity-icon">{icon}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const RoomCard = ({ image, title, amenities }) => (
  <div className="room-card">
    <img src={image} alt={title} className="room-image" />
    <div className="room-details">
      <h3>{title}</h3>
      <ul>
        {amenities.map((amenity, index) => <li key={index}>{amenity}</li>)}
      </ul>
    </div>
  </div>
);

const SpaceCard = ({ image, title, description }) => (
  <div className="space-card">
    <img src={image} alt={title} className="space-image" />
    <div className="space-overlay">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
);

// --- DICCIONARIO DE TRADUCCIONES ---
const translations = {
  es: {
    menu: { home: "Inicio", services: "Servicios", rooms: "Habitaciones", availability: "Disponibilidad", contact: "Contacto" },
    hero: { badge: "Bienvenidos a Rancho Licona", title1: "Tu Escape Exclusivo", title2: "frente al Mar", desc: "Disfruta de comodidad y diversión privada con instalaciones de primer nivel.", btn: "Ver Disponibilidad" },
    services: { 
      title: "Servicios Exclusivos",
      pool: { title: "Piscinas Privadas", desc: "Piscinas familiares para niños y adultos con espectacular iluminación nocturna." },
      kitchen: { title: "Cocina Equipada", desc: "Cocina completa para preparar tus platillos favoritos." },
      bbq: { title: "Área de Asados", desc: "Parrilla lista para tus barbacoas." },
      fire: { title: "Fogatas Nocturnas", desc: "Área diseñada para fogatas nocturnas bajo las estrellas." },
      parking: { title: "Parqueo Seguro", desc: "Amplio espacio privado para hasta 5 vehículos dentro de la propiedad." },
      pet: { title: "Pet Friendly", desc: "Tus mascotas son más que bienvenidas en nuestro rancho." }
    },
    rooms: {
      title: "Habitaciones Climatizadas", intro: "Todas nuestras habitaciones cuentan con A/C y baño privado para tu total comodidad.",
      room1: "Habitación 1", room2: "Habitación 2", room3: "Habitación 3",
      bed2: "2 Camas Matrimoniales", bed1bunk: "1 Cama Matrimonial y 1 Camarote",
      ac: "A/C y Baño Privado", pax: "Hasta 4 personas"
    },
    spaces: {
      title: "Espacios", intro: "Zonas diseñadas para la relajación total y el esparcimiento familiar.",
      hammocks: { title: "Zona de Hamacas", desc: "Relájate con la brisa del mar bajo la sombra fresca de nuestro corredor principal." },
      terrace: { title: "Terraza de Descanso", desc: "Cómodas camas de exterior ideales para disfrutar del atardecer o una buena lectura." },
      lounge: { title: "Área Social Rústica", desc: "Un espacio acogedor con muebles de madera artesanal, perfecto para conversar en familia o tomar un rico café." }
    },
    calendar: { title: "Consultar Disponibilidad", intro: "Revisa qué fechas están libres. Las fechas marcadas en tu Google Calendar aparecerán aquí.", question: "¿Encontraste tus fechas ideales?", btn: "Consultar y Reservar por WhatsApp" },
    gallery: { title: "Galería de Fotos", intro: "Desliza hacia los lados para explorar cada rincón de Rancho Licona.", swipe: "← Desliza para ver más fotos →" },
    contact: { title: "Contáctanos", location: "Ubicación", phone: "Teléfono/WhatsApp", question: "¿Tienes alguna duda o estás listo para reservar tus fechas?", btn: "Escríbenos por WhatsApp" },
    footer: "Rancho Licona San Marcelino. Todos los derechos reservados.",
    roulette: {
      giftBtn: "¡Gana Beneficios!",
      popupTitle: "¡Gira y Gana Beneficios! 🎁",
      popupDesc: "Déjanos tu contacto para activar la ruleta y ganar premios exclusivos para tu estadía.",
      nameInput: "Tu Nombre", phoneInput: "Tu WhatsApp (Ej. 7777-7777)",
      unlockBtn: "Desbloquear Ruleta", validating: "Validando...",
      luck: "¡Buena Suerte",
      spinBtn: "¡GIRAR AHORA!", spinning: "Girando...",
      congrats: "¡Felicidades! Ganaste:",
      claimBtn: "Reclamar Beneficio por WhatsApp",
      whatsappMsg: "Hola Rancho Licona, me gustaría solicitar información para reservar.",
      alertExists: "¡Este número de WhatsApp ya participó en la ruleta! Recuerda que es válido un solo intento por persona.",
      alertError: "Hubo un problema de conexión al validar tus datos. Inténtalo de nuevo.",
      prize1: "5% Descuento", prize2: "Kit Instagrameable", prize3: "1 Hora Extra", 
      prize4: "Kit Playero", prize5: "2 Horas Extras", prize6: "Kit Cafetero"
    }
  },
  en: {
    menu: { home: "Home", services: "Amenities", rooms: "Rooms", availability: "Availability", contact: "Contact" },
    hero: { badge: "Welcome to Rancho Licona", title1: "Your Exclusive", title2: "Beachfront Escape", desc: "Enjoy private comfort and fun with first-class facilities.", btn: "Check Availability" },
    services: { 
      title: "Exclusive Amenities",
      pool: { title: "Private Pools", desc: "Family pools for kids and adults with spectacular night lighting." },
      kitchen: { title: "Equipped Kitchen", desc: "Full kitchen to prepare your favorite meals." },
      bbq: { title: "BBQ Area", desc: "Grill ready for your barbecues." },
      fire: { title: "Night Bonfires", desc: "Area designed for night bonfires under the stars." },
      parking: { title: "Secure Parking", desc: "Ample private space for up to 5 vehicles inside the property." },
      pet: { title: "Pet Friendly", desc: "Your pets are more than welcome at our beach house." }
    },
    rooms: {
      title: "Air-Conditioned Rooms", intro: "All our rooms have A/C and private bathrooms for your total comfort.",
      room1: "Room 1", room2: "Room 2", room3: "Room 3",
      bed2: "2 Double Beds", bed1bunk: "1 Double Bed & 1 Bunk Bed",
      ac: "A/C & Private Bath", pax: "Up to 4 people"
    },
    spaces: {
      title: "Spaces", intro: "Areas designed for total relaxation and family recreation.",
      hammocks: { title: "Hammock Zone", desc: "Relax with the sea breeze under the cool shade of our main corridor." },
      terrace: { title: "Rest Terrace", desc: "Comfortable outdoor beds ideal for enjoying the sunset or a good read." },
      lounge: { title: "Rustic Lounge Area", desc: "A cozy space with handcrafted wooden furniture, perfect for chatting with family or having coffee." }
    },
    calendar: { title: "Check Availability", intro: "Check which dates are free. Dates marked on the Google Calendar will appear here.", question: "Found your ideal dates?", btn: "Inquire & Book via WhatsApp" },
    gallery: { title: "Photo Gallery", intro: "Swipe sideways to explore every corner of Rancho Licona.", swipe: "← Swipe for more photos →" },
    contact: { title: "Contact Us", location: "Location", phone: "Phone/WhatsApp", question: "Have any questions or ready to book your dates?", btn: "Message us on WhatsApp" },
    footer: "Rancho Licona San Marcelino. All rights reserved.",
    roulette: {
      giftBtn: "Win Perks!",
      popupTitle: "Spin & Win Perks! 🎁",
      popupDesc: "Leave us your contact info to activate the roulette and win exclusive prizes for your stay.",
      nameInput: "Your Name", phoneInput: "Your WhatsApp (e.g. 7777-7777)",
      unlockBtn: "Unlock Roulette", validating: "Validating...",
      luck: "Good Luck",
      spinBtn: "SPIN NOW!", spinning: "Spinning...",
      congrats: "Congratulations! You won:",
      claimBtn: "Claim Perk via WhatsApp",
      whatsappMsg: "Hello Rancho Licona, I would like to request information to book.",
      alertExists: "This WhatsApp number has already participated in the roulette! Remember, only one attempt per person is allowed.",
      alertError: "There was a connection problem validating your data. Please try again.",
      prize1: "5% Discount", prize2: "Instagram Kit", prize3: "1 Extra Hour", 
      prize4: "Beach Kit", prize5: "2 Extra Hours", prize6: "Coffee Kit"
    }
  }
};

function App() {
  const [lang, setLang] = useState('es'); // Estado para el idioma actual
  const t = translations[lang]; // Variable rápida para acceder a los textos

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [showPopup, setShowPopup] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [leadCaptured, setLeadCaptured] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const [prizeIndex, setPrizeIndex] = useState(null);
  const [hasSpun, setHasSpun] = useState(false);
  
  const canvasRef = useRef(null);

  // Opciones de la ruleta dinámicas según el idioma
  const rouletteOptions = [
    { text: t.roulette.prize1, color: '#1A365D' },
    { text: t.roulette.prize2, color: '#C19A6B' },
    { text: t.roulette.prize3, color: '#0EA5E9' },
    { text: t.roulette.prize4, color: '#1A365D' },
    { text: t.roulette.prize5, color: '#C19A6B' },
    { text: t.roulette.prize6, color: '#0EA5E9' },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const activeHeroImages = isMobile ? heroImagesMobile : heroImagesDesktop;

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % activeHeroImages.length);
    }, 4000);
    return () => clearInterval(slideInterval);
  }, [activeHeroImages.length]);

  // Lanzar popup automático de la ruleta después de 30 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!localStorage.getItem('roulettePlayed')) {
        setShowPopup(true);
      }
    }, 30000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (showPopup && leadCaptured && canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const radius = canvas.width / 2;
      const sliceAngle = (2 * Math.PI) / rouletteOptions.length;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      rouletteOptions.forEach((opt, i) => {
        ctx.beginPath();
        ctx.moveTo(radius, radius);
        ctx.arc(radius, radius, radius, i * sliceAngle, (i + 1) * sliceAngle);
        ctx.fillStyle = opt.color;
        ctx.fill();
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#ffffff';
        ctx.stroke();
        ctx.save();
        ctx.translate(radius, radius);
        ctx.rotate(i * sliceAngle + sliceAngle / 2);
        ctx.textAlign = 'right';
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 14px sans-serif';
        ctx.fillText(opt.text, radius - 20, 5);
        ctx.restore();
      });
      ctx.beginPath();
      ctx.arc(radius, radius, 15, 0, 2 * Math.PI);
      ctx.fillStyle = '#ffffff';
      ctx.fill();
      ctx.strokeStyle = '#333333';
      ctx.stroke();
    }
  }, [showPopup, leadCaptured, lang]); // Agregamos 'lang' para que se redibuje si cambian de idioma

  const closePopup = () => setShowPopup(false);
  const openPopup = () => setShowPopup(true);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!name || !phone) return;
    setIsChecking(true);
    try {
      const leadsRef = collection(db, "leads");
      const q = query(leadsRef, where("phone", "==", phone.trim()));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        alert(t.roulette.alertExists);
        setIsChecking(false);
        return;
      }
      setLeadCaptured(true);
    } catch (error) {
      console.error("Error al consultar Firebase:", error);
      alert(t.roulette.alertError);
    } finally {
      setIsChecking(false);
    }
  };

  const handleSpinClick = () => {
    if (isSpinning) return;
    setIsSpinning(true);
    const randomIndex = Math.floor(Math.random() * rouletteOptions.length);
    setPrizeIndex(randomIndex);
    const degreesPerSlice = 360 / rouletteOptions.length;
    const baseSpins = 5 * 360; 
    const targetRotation = baseSpins + 270 - (randomIndex * degreesPerSlice + degreesPerSlice / 2);
    setRotation(targetRotation);
    setTimeout(async () => {
      setIsSpinning(false);
      setHasSpun(true);
      try {
        await addDoc(collection(db, "leads"), {
          name: name.trim(),
          phone: phone.trim(),
          prize: rouletteOptions[randomIndex].text,
          createdAt: new Date()
        });
        localStorage.setItem('roulettePlayed', 'true');
      } catch (error) {
        console.error("Error al guardar los datos en Firebase:", error);
      }
    }, 4000);
  };

  const getWhatsAppLink = (prizeText = null) => {
    let message = prizeText 
      ? `Hola Rancho Licona, soy ${name}. Jugué en la ruleta de su página y gané: *${prizeText}*. Me gustaría reservar.`
      : t.roulette.whatsappMsg;
    return `https://wa.me/50366815947?text=${encodeURIComponent(message)}`;
  };

  const toggleLanguage = () => {
    setLang(lang === 'es' ? 'en' : 'es');
  };

  return (
    <div className="App">
      <button className="floating-gift-btn" onClick={openPopup} title={t.roulette.giftBtn}>🎁</button>
      <a href={getWhatsAppLink()} target="_blank" rel="noreferrer" className="floating-whatsapp-btn" title={t.menu.contact}>
        <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="whatsapp-icon" />
      </a>

      {showPopup && (
        <div className="roulette-overlay">
          <div className="roulette-modal">
            <button className="close-btn" onClick={closePopup}>✖</button>
            {!leadCaptured ? (
              <div className="lead-form">
                <h2>{t.roulette.popupTitle}</h2>
                <p>{t.roulette.popupDesc}</p>
                <form onSubmit={handleFormSubmit}>
                  <input type="text" placeholder={t.roulette.nameInput} value={name} onChange={(e) => setName(e.target.value)} required />
                  <input type="tel" placeholder={t.roulette.phoneInput} value={phone} onChange={(e) => setPhone(e.target.value)} required />
                  <button type="submit" className="cta-button" disabled={isChecking}>
                    {isChecking ? t.roulette.validating : t.roulette.unlockBtn}
                  </button>
                </form>
              </div>
            ) : (
              <div className="roulette-container">
                <h2>{t.roulette.luck}, {name}! 🍀</h2>
                <div className="wheel-box-native">
                  <div className="wheel-pointer-native">▼</div>
                  <canvas 
                    ref={canvasRef} 
                    width={300} 
                    height={300} 
                    style={{ transform: `rotate(${rotation}deg)`, transition: isSpinning ? 'transform 4s cubic-bezier(0.15, 0.85, 0.35, 1)' : 'none' }}
                  />
                </div>
                {!hasSpun ? (
                  <button className="cta-button spin-btn" onClick={handleSpinClick} disabled={isSpinning}>
                    {isSpinning ? t.roulette.spinning : t.roulette.spinBtn}
                  </button>
                ) : (
                  <div className="prize-result">
                    <h3>{t.roulette.congrats}<br /><span>{rouletteOptions[prizeIndex].text}</span> 🎉</h3>
                    <a href={getWhatsAppLink(rouletteOptions[prizeIndex].text)} target="_blank" rel="noreferrer" className="cta-button whatsapp-button block-btn">
                      {t.roulette.claimBtn}
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <header className="header">
        <div className="container">
          <div className="logo-container">
            <img src="/img/logo_Rancho_Licona.png" alt="Rancho Licona Logo" className="header-logo-img" />
          </div>
          
          <nav className={`nav ${mobileMenuOpen ? 'open' : ''}`}>
            <ul>
              <li><a href="#inicio" onClick={() => setMobileMenuOpen(false)}>{t.menu.home}</a></li>
              <li><a href="#servicios" onClick={() => setMobileMenuOpen(false)}>{t.menu.services}</a></li>
              <li><a href="#habitaciones" onClick={() => setMobileMenuOpen(false)}>{t.menu.rooms}</a></li>
              <li><a href="#calendario" onClick={() => setMobileMenuOpen(false)}>{t.menu.availability}</a></li>
              <li><a href="#contacto" onClick={() => setMobileMenuOpen(false)}>{t.menu.contact}</a></li>
            </ul>
          </nav>

          <div className="header-actions">
            <button onClick={toggleLanguage} className="lang-toggle-btn">
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
            <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </header>

      <section id="inicio" className="hero">
        {activeHeroImages.map((img, index) => (
          <div key={index} className={`hero-slide ${index === currentSlide ? 'active' : ''}`} style={{ backgroundImage: `url('${img}')` }}></div>
        ))}
        <div className="hero-image-overlay"></div>
        <div className="hero-content">
          <span className="hero-badge">{t.hero.badge}</span>
          <h1>{t.hero.title1}<br/>{t.hero.title2}</h1>
          <p>{t.hero.desc}</p>
          <a href="#calendario" className="cta-button">{t.hero.btn}</a>
        </div>
        <div className="slider-indicators">
          {activeHeroImages.map((_, index) => (
            <span key={index} className={`dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)}></span>
          ))}
        </div>
      </section>

      <section id="servicios" className="amenities">
        <div className="container">
          <h2>{t.services.title}</h2>
          <div className="amenities-grid">
            <AmenityCard icon="🏊‍♂️" title={t.services.pool.title} description={t.services.pool.desc} />
            <AmenityCard icon="🍳" title={t.services.kitchen.title} description={t.services.kitchen.desc} />
            <AmenityCard icon="🍖" title={t.services.bbq.title} description={t.services.bbq.desc} />
            <AmenityCard icon="🔥" title={t.services.fire.title} description={t.services.fire.desc} />
            <AmenityCard icon="🚗" title={t.services.parking.title} description={t.services.parking.desc} />
            <AmenityCard icon="🐾" title={t.services.pet.title} description={t.services.pet.desc} />
          </div>
        </div>
      </section>

      <section id="habitaciones" className="rooms">
        <div className="container">
          <h2>{t.rooms.title}</h2>
          <p className="rooms-intro">{t.rooms.intro}</p>
          <div className="rooms-grid">
            <RoomCard image="/img/foto_habitacion_1.jpg" title={t.rooms.room1} amenities={[t.rooms.bed2, t.rooms.ac, t.rooms.pax]} />
            <RoomCard image="/img/foto_habitacion_2.jpg" title={t.rooms.room2} amenities={[t.rooms.bed2, t.rooms.ac, t.rooms.pax]} />
            <RoomCard image="/img/foto_habitacion_3.jpg" title={t.rooms.room3} amenities={[t.rooms.bed1bunk, t.rooms.ac, t.rooms.pax]} />
          </div>
        </div>
      </section>

      <section className="spaces">
        <div className="container">
          <h2>{t.spaces.title}</h2>
          <p className="rooms-intro">{t.spaces.intro}</p>
          <div className="spaces-grid">
            <SpaceCard image="/img/hamacas_rancho_licona.jpg" title={t.spaces.hammocks.title} description={t.spaces.hammocks.desc} />
            <SpaceCard image="/img/areadeestar.jpg" title={t.spaces.terrace.title} description={t.spaces.terrace.desc} />
            <SpaceCard image="/img/areadeestar2.jpg" title={t.spaces.lounge.title} description={t.spaces.lounge.desc} />
          </div>
        </div>
      </section>

      <section id="calendario" className="calendar-section">
        <div className="container">
          <h2>{t.calendar.title}</h2>
          <p className="rooms-intro">{t.calendar.intro}</p>
          <div className="calendar-wrapper">
            <iframe src="https://calendar.google.com/calendar/embed?src=q1sqpu5knq9944gguej5m619fk%40group.calendar.google.com&ctz=America%2FEl_Salvador" style={{border: "none"}} width="100%" height="600" frameBorder="0" scrolling="no" title="Calendario de Disponibilidad"></iframe>
          </div>
          <div className="calendar-actions">
            <p>{t.calendar.question}</p>
            <a href={getWhatsAppLink()} target="_blank" rel="noreferrer" className="cta-button whatsapp-button">{t.calendar.btn}</a>
          </div>
        </div>
      </section>

      <section id="galeria" className="gallery">
        <div className="container">
          <h2>{t.gallery.title}</h2>
          <p className="rooms-intro">{t.gallery.intro}</p>
          <div className="gallery-slider">
            {galleryImages.map((img, index) => (
              <div key={index} className="gallery-slide-item cursor-pointer" onClick={() => setLightboxIndex(index)}>
                <img src={img} alt={`Rancho Licona Galería ${index + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
          <div className="swipe-indicator"><span>{t.gallery.swipe}</span></div>
        </div>
      </section>

      {lightboxIndex !== null && (
        <div className="lightbox-overlay" onClick={() => setLightboxIndex(null)}>
          <button className="lightbox-close" onClick={() => setLightboxIndex(null)}>✖</button>
          <button className="lightbox-nav prev" onClick={(e) => { e.stopPropagation(); setLightboxIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1)); }}>&#10094;</button>
          <img src={galleryImages[lightboxIndex]} alt={`Ampliación ${lightboxIndex + 1}`} className="lightbox-img" onClick={(e) => e.stopPropagation()} />
          <button className="lightbox-nav next" onClick={(e) => { e.stopPropagation(); setLightboxIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1)); }}>&#10095;</button>
          <div className="lightbox-counter">{lightboxIndex + 1} / {galleryImages.length}</div>
        </div>
      )}

      <section id="contacto" className="contact">
        <div className="container">
          <h2>{t.contact.title}</h2>
          <div className="contact-info">
            <p><strong>{t.contact.location}:</strong> Playa San Marcelino, Costa del Sol, La Paz, El Salvador.</p>
            <p><strong>{t.contact.phone}:</strong> +503 6681-5947</p>
            <p><strong>Email:</strong> info@rancholicona.com</p>
          </div>
          
          <p style={{ marginBottom: '20px', fontSize: '1.1rem' }}>
            {t.contact.question}
          </p>
          <a 
            href={getWhatsAppLink()} 
            target="_blank" 
            rel="noreferrer" 
            className="cta-button"
            style={{ backgroundColor: '#25D366', color: 'white' }}
          >
            {t.contact.btn}
          </a>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} {t.footer}</p>
        </div>
      </footer>
    </div>
  );
}

export default App;